import moment from 'moment'
/**
 * 时间戳转换成日期
 * @param {\} v 时间戳
 * @param {*} format 格式化日期  注意区分大小写！ HH:24小时制 hh:12小时制
 */
export function formatTime(v, format = 'YYYY/MM/DD') {
  if (v) {
    return moment(v).format(format)
  }
  return ''
}
export function throttle(fn, delay) {
  let lastTime
  let timer
  let delayA = delay || 3000
  return function () {
    let args = arguments
    // 记录当前函数触发的时间
    let nowTime = Date.now()
    if (lastTime && nowTime - lastTime < delayA) {
      clearTimeout(timer)
      timer = setTimeout(function () {
        // 记录上一次函数触发的时间
        lastTime = nowTime
        // 修正this指向问题
        fn.apply(this, args)
      }, delayA)
    } else {
      lastTime = nowTime
      fn.apply(this, args)
    }
  }
}
